/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { getSubmitData, processHeaders, SCOPE_TYPES } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';
import { appendJSActionQueryParams } from '../../utils/case-utils';
import ObjectTransformer from '../../utils/object-transformer';
import { ACTION_EXECUTE_OBJECT_ACTION } from '../../store/state/actions';

const EXECUTE_OBJECT_WIDE_ACTION_DXAPI_LOG_ERROR_MESSAGE =
  'Error occurred during ajax call at executeObjectWideAction Epic : ';

export const executeObjectWideActionRequest = (
  actionInPayload: Action['payload'],
  options: { state$: { value: any } }
) => {
  const { assignmentID, actionID, caseID, context, additionalHeaders = {}, jsActionQueryParams } = actionInPayload;

  const { state$ } = options;

  const viewType = SCOPE_TYPES.PAGE;
  const actionName = ACTION_EXECUTE_OBJECT_ACTION;

  const requestPayload = {
    assignmentID,
    actionID,
    viewType,
    objectID: caseID
  };

  let { restApi } = resolveRestApi(actionName, requestPayload);
  const { reqType } = resolveRestApi(actionName, requestPayload);

  if (viewType && !restApi?.includes('viewType=')) {
    restApi = !restApi?.includes('?') ? `${restApi}?viewType=${viewType}` : `${restApi}&viewType=${viewType}`;
  }
  restApi = appendJSActionQueryParams(jsActionQueryParams, restApi);
  actionInPayload.viewType = viewType;

  const { content } = getSubmitData(context, { isObjectWideAction: true });
  const objectInfoHeaders = state$.value.data[context]?.objectInfo?.headers || {};
  const { etag } = objectInfoHeaders;
  const reqHeaders = {
    'if-match': etag,
    ...additionalHeaders
  };

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        body: content,
        headers: reqHeaders
      },
      context
    )
  ).pipe(
    map((response) => {
      const { data, headers } = response;
      ObjectTransformer.analyseResponse(response.data);
      return {
        actionInPayload,
        response: data,
        headers: processHeaders({ ...reqHeaders, ...headers })
      };
    }),
    logAndCatchError(EXECUTE_OBJECT_WIDE_ACTION_DXAPI_LOG_ERROR_MESSAGE, context)
  );
};

export default executeObjectWideActionRequest;
